import { ArrowLeftIcon, ArrowRightIcon } from '@/components/Icons';

import { R } from '@/caregiverSpace/resources/Texts.resx';
import { cn } from '@/lib/cn';

type ViewerNavArrowProps = {
    direction: 'left' | 'right';
    disabled: boolean;
    onClick: () => void;
};

export const ViewerNavArrow = ({
    direction,
    disabled,
    onClick,
}: ViewerNavArrowProps) => {
    const isLeft = direction === 'left';
    return (
        <button
            type="button"
            className={cn(
                'absolute z-10 flex h-10 w-10 cursor-pointer items-center justify-center rounded-full border-0 bg-white text-gray-800 shadow-md hover:bg-gray-100 disabled:cursor-default disabled:opacity-30',
                isLeft ? 'left-3' : 'right-3',
            )}
            aria-label={isLeft ? R.PreviousAttachment : R.NextAttachment}
            disabled={disabled}
            onClick={onClick}
        >
            {isLeft ? (
                <ArrowLeftIcon className="h-5 w-5" />
            ) : (
                <ArrowRightIcon className="h-5 w-5" />
            )}
        </button>
    );
};
